import * as z from "zod"

export const contactFormSchema = z.object({
  name: z.string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .max(70, "Name must be less than 70 characters")
    .refine((val) => !/(https?:\/\/|www\.|<[^>]+>)/i.test(val), {
      message: "Name cannot contain URLs or invalid characters",
    }),
  phone: z.string()
    .trim()
    .min(10, "Please enter a valid phone number (at least 10 digits)")
    .max(25, "Phone number is too long")
    .regex(
      /^(\+?\d{1,3}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
      "Please enter a valid phone number (e.g. (813) 123-4567 or 813-123-4567)"
    ),
  email: z.string()
    .trim()
    .toLowerCase()
    .email("Please enter a valid email address")
    .max(100, "Email address is too long"),
  message: z.string()
    .trim()
    .min(10, "Message must be at least 10 characters")
    .max(2000, "Message must be less than 2000 characters"),
  // Captcha response entered by the user
  captcha: z.number({
    message: "Please enter the math answer",
  }),
  // Token generated for the captcha challenge (for cryptographic server verification)
  captchaToken: z.string().min(1, "Security token missing"),
  // Honeypot field (hidden from genuine users, bots will fill it)
  hp_website: z.string().max(0, "Spam detected").optional().or(z.literal("")),
  // Timestamp when form was loaded on the client
  formStartTime: z.number().optional(),
})

export type ContactFormValues = z.infer<typeof contactFormSchema>